var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.collapsed)?_c('span',[_vm._v("\n  "+_vm._s(_vm.text.substring(0,50))+" "),(_vm.text.length > 50)?_c('a',{on:{"click":_vm.expand}},[_vm._v("More")]):_vm._e()]):_c('span',[_vm._v("\n  "+_vm._s(_vm.text)+" "),(_vm.text.length > 50)?_c('a',{on:{"click":_vm.contract}},[_vm._v("Less")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }